@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(1_993_030_060)
internal val Res.string.ui_campaigns_edit_visual_guidelines_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_visual_guidelines_title", "ui_campaigns_edit_visual_guidelines_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6969, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6681, 73),
      ))
    }

@delegate:ResourceContentHash(-1_578_765_116)
internal val Res.string.ui_campaigns_edit_warn_name_required: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_name_required", "ui_campaigns_edit_warn_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7047, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6755, 80),
      ))
    }

@delegate:ResourceContentHash(-103_907_719)
internal val Res.string.ui_campaigns_edit_warn_save_failed: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_save_failed", "ui_campaigns_edit_warn_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7128, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6836, 58),
      ))
    }

@delegate:ResourceContentHash(196_120_729)
internal val Res.string.ui_campaigns_edit_warn_select_device: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_select_device", "ui_campaigns_edit_warn_select_device", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7203, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6895, 80),
      ))
    }

@delegate:ResourceContentHash(-2_134_920_235)
internal val Res.string.ui_campaigns_edit_warn_set_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_set_assets", "ui_campaigns_edit_warn_set_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7288, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6976, 85),
      ))
    }

@delegate:ResourceContentHash(-1_238_941_292)
internal val Res.string.ui_campaigns_listing_btn_new: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_btn_new", "ui_campaigns_listing_btn_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7382, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7062, 48),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.ui_campaigns_listing_btn_ok: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_btn_ok", "ui_campaigns_listing_btn_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7431, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7111, 39),
      ))
    }

@delegate:ResourceContentHash(44_400_671)
internal val Res.string.ui_campaigns_listing_btn_reset: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_btn_reset", "ui_campaigns_listing_btn_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7475, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7151, 46),
      ))
    }

@delegate:ResourceContentHash(-2_129_802_091)
internal val Res.string.ui_campaigns_listing_filter_date_any: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_filter_date_any", "ui_campaigns_listing_filter_date_any", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7534, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7198, 56),
      ))
    }

@delegate:ResourceContentHash(1_566_795_854)
internal val Res.string.ui_campaigns_listing_filter_date_format: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_filter_date_format", "ui_campaigns_listing_filter_date_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7603, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7255, 63),
      ))
    }

@delegate:ResourceContentHash(914_843_083)
internal val Res.string.ui_campaigns_listing_filter_state_prefix: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_filter_state_prefix", "ui_campaigns_listing_filter_state_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7667, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7319, 56),
      ))
    }

@delegate:ResourceContentHash(752_949_821)
internal val Res.string.ui_campaigns_listing_header_asset: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_asset", "ui_campaigns_listing_header_asset", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7728, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7376, 49),
      ))
    }

@delegate:ResourceContentHash(79_735_552)
internal val Res.string.ui_campaigns_listing_header_geo: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_geo", "ui_campaigns_listing_header_geo", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7778, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7426, 43),
      ))
    }

@delegate:ResourceContentHash(-32_286_540)
internal val Res.string.ui_campaigns_listing_header_identity: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_identity", "ui_campaigns_listing_header_identity", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7822, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7470, 56),
      ))
    }

@delegate:ResourceContentHash(1_686_638_496)
internal val Res.string.ui_campaigns_listing_header_interval: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_interval", "ui_campaigns_listing_header_interval", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7879, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7527, 56),
      ))
    }

@delegate:ResourceContentHash(464_968_481)
internal val Res.string.ui_campaigns_listing_header_node: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_node", "ui_campaigns_listing_header_node", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7936, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7584, 48),
      ))
    }

@delegate:ResourceContentHash(157_918_156)
internal val Res.string.ui_campaigns_listing_header_reach: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_reach", "ui_campaigns_listing_header_reach", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7985, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7633, 49),
      ))
    }

@delegate:ResourceContentHash(-1_315_954_198)
internal val Res.string.ui_campaigns_listing_header_state: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_state", "ui_campaigns_listing_header_state", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8035, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7683, 49),
      ))
    }

@delegate:ResourceContentHash(-191_297_421)
internal val Res.string.ui_campaigns_listing_header_visual: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_visual", "ui_campaigns_listing_header_visual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8085, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7733, 50),
      ))
    }

@delegate:ResourceContentHash(-509_402_608)
internal val Res.string.ui_campaigns_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_search_placeholder", "ui_campaigns_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8136, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7784, 63),
      ))
    }

@delegate:ResourceContentHash(-1_669_178_289)
internal val Res.string.ui_campaigns_listing_showing: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_showing", "ui_campaigns_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8216, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7848, 84),
      ))
    }

@delegate:ResourceContentHash(255_620_874)
internal val Res.string.ui_campaigns_splash_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_splash_desc", "ui_campaigns_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8305, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7933, 196),
      ))
    }

@delegate:ResourceContentHash(2_075_806_342)
internal val Res.string.ui_campaigns_splash_title: StringResource by lazy {
      StringResource("string:ui_campaigns_splash_title", "ui_campaigns_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8518, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8130, 45),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_company_dialog_btn_cancel: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_cancel", "ui_company_dialog_btn_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8564, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8176, 44),
      ))
    }

@delegate:ResourceContentHash(-1_918_958_121)
internal val Res.string.ui_company_dialog_btn_confirm: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_confirm", "ui_company_dialog_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8613, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8221, 49),
      ))
    }

@delegate:ResourceContentHash(-1_259_938_483)
internal val Res.string.ui_company_dialog_btn_delete: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_delete", "ui_company_dialog_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8663, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8271, 56),
      ))
    }

@delegate:ResourceContentHash(1_437_937_459)
internal val Res.string.ui_company_dialog_btn_rename: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_rename", "ui_company_dialog_btn_rename", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8720, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8328, 56),
      ))
    }

@delegate:ResourceContentHash(-1_246_631_216)
internal val Res.string.ui_company_dialog_btn_switch: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_switch", "ui_company_dialog_btn_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8781, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8385, 60),
      ))
    }

@delegate:ResourceContentHash(1_062_343_038)
internal val Res.string.ui_company_dialog_delete_title: StringResource by lazy {
      StringResource("string:ui_company_dialog_delete_title", "ui_company_dialog_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8846, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8446, 58),
      ))
    }

@delegate:ResourceContentHash(-534_585_888)
internal val Res.string.ui_company_dialog_delete_warning: StringResource by lazy {
      StringResource("string:ui_company_dialog_delete_warning", "ui_company_dialog_delete_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8905, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8505, 240),
      ))
    }

@delegate:ResourceContentHash(-69_592_949)
internal val Res.string.ui_company_dialog_rename_placeholder: StringResource by lazy {
      StringResource("string:ui_company_dialog_rename_placeholder", "ui_company_dialog_rename_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9174, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8746, 60),
      ))
    }

@delegate:ResourceContentHash(1_824_521_994)
internal val Res.string.ui_company_dialog_rename_title: StringResource by lazy {
      StringResource("string:ui_company_dialog_rename_title", "ui_company_dialog_rename_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9239, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8807, 58),
      ))
    }

@delegate:ResourceContentHash(-738_427_141)
internal val Res.string.ui_company_dialog_title: StringResource by lazy {
      StringResource("string:ui_company_dialog_title", "ui_company_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9302, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8866, 51),
      ))
    }

@delegate:ResourceContentHash(59_977_868)
internal val Res.string.ui_company_listing_btn_add_company: StringResource by lazy {
      StringResource("string:ui_company_listing_btn_add_company", "ui_company_listing_btn_add_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9354, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8918, 58),
      ))
    }

@delegate:ResourceContentHash(959_713_004)
internal val Res.string.ui_company_listing_btn_load_more: StringResource by lazy {
      StringResource("string:ui_company_listing_btn_load_more", "ui_company_listing_btn_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9413, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8977, 52),
      ))
    }

@delegate:ResourceContentHash(1_155_161_766)
internal val Res.string.ui_company_listing_header_counters: StringResource by lazy {
      StringResource("string:ui_company_listing_header_counters", "ui_company_listing_header_counters", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9474, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9030, 70),
      ))
    }

@delegate:ResourceContentHash(-1_800_739_518)
internal val Res.string.ui_company_listing_header_name: StringResource by lazy {
      StringResource("string:ui_company_listing_header_name", "ui_company_listing_header_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9545, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9101, 54),
      ))
    }

@delegate:ResourceContentHash(-967_613_796)
internal val Res.string.ui_company_listing_no_companies_found: StringResource by lazy {
      StringResource("string:ui_company_listing_no_companies_found", "ui_company_listing_no_companies_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9600, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9156, 69),
      ))
    }

@delegate:ResourceContentHash(1_140_172_190)
internal val Res.string.ui_company_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_company_listing_search_placeholder", "ui_company_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9678, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9226, 73),
      ))
    }

@delegate:ResourceContentHash(-896_686_024)
internal val Res.string.ui_company_listing_showing: StringResource by lazy {
      StringResource("string:ui_company_listing_showing", "ui_company_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9752, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9300, 86),
      ))
    }

@delegate:ResourceContentHash(-1_963_325_949)
internal val Res.string.ui_company_splash_desc: StringResource by lazy {
      StringResource("string:ui_company_splash_desc", "ui_company_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9835, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9387, 126),
      ))
    }

@delegate:ResourceContentHash(-1_995_450_493)
internal val Res.string.ui_company_splash_title: StringResource by lazy {
      StringResource("string:ui_company_splash_title", "ui_company_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9970, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9514, 43),
      ))
    }

@delegate:ResourceContentHash(-1_594_403_747)
internal val Res.string.ui_devices_detail_device_actions_btn_close: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_close", "ui_devices_detail_device_actions_btn_close", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10010, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9558, 58),
      ))
    }

@delegate:ResourceContentHash(128_979_711)
internal val Res.string.ui_devices_detail_device_actions_btn_reboot: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_reboot", "ui_devices_detail_device_actions_btn_reboot", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10073, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9617, 59),
      ))
    }

@delegate:ResourceContentHash(-752_741_875)
internal val Res.string.ui_devices_detail_device_actions_btn_update_runtime: StringResource by
    lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_update_runtime", "ui_devices_detail_device_actions_btn_update_runtime", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10145, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9677, 79),
      ))
    }

@delegate:ResourceContentHash(1_454_388_143)
internal val Res.string.ui_devices_detail_device_actions_btn_update_www: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_btn_update_www", "ui_devices_detail_device_actions_btn_update_www", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10229, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9757, 71),
      ))
    }

@delegate:ResourceContentHash(1_645_108_522)
internal val Res.string.ui_devices_detail_device_actions_dialog_title: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_dialog_title", "ui_devices_detail_device_actions_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10305, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9829, 73),
      ))
    }

@delegate:ResourceContentHash(1_165_142_392)
internal val Res.string.ui_devices_detail_device_actions_reboot_queued: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_reboot_queued", "ui_devices_detail_device_actions_reboot_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10379, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9903, 78),
      ))
    }

@delegate:ResourceContentHash(2_040_675_498)
internal val Res.string.ui_devices_detail_device_actions_update_queued: StringResource by lazy {
      StringResource("string:ui_devices_detail_device_actions_update_queued", "ui_devices_detail_device_actions_update_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10486, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9982, 94),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_devices_detail_devicedui_btn_cancel: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_cancel", "ui_devices_detail_devicedui_btn_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10601, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10077, 54),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_devices_detail_devicedui_btn_delete: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_delete", "ui_devices_detail_devicedui_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10660, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10132, 54),
      ))
    }

@delegate:ResourceContentHash(988_176_674)
internal val Res.string.ui_devices_detail_devicedui_btn_device_actions: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_device_actions", "ui_devices_detail_devicedui_btn_device_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10719, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10187, 74),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_devices_detail_devicedui_btn_edit: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_edit", "ui_devices_detail_devicedui_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10794, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10262, 52),
      ))
    }

@delegate:ResourceContentHash(1_521_527_482)
internal val Res.string.ui_devices_detail_devicedui_btn_screenshot: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_btn_screenshot", "ui_devices_detail_devicedui_btn_screenshot", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10847, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10315, 66),
      ))
    }

@delegate:ResourceContentHash(1_023_558_733)
internal val Res.string.ui_devices_detail_devicedui_campaigns_empty: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_campaigns_empty", "ui_devices_detail_devicedui_campaigns_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10918, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10382, 79),
      ))
    }

@delegate:ResourceContentHash(-1_723_276_995)
internal val Res.string.ui_devices_detail_devicedui_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_delete_confirm_message", "ui_devices_detail_devicedui_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11002, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10462, 158),
      ))
    }

@delegate:ResourceContentHash(-1_251_850_257)
internal val Res.string.ui_devices_detail_devicedui_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_delete_confirm_title", "ui_devices_detail_devicedui_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11177, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10621, 76),
      ))
    }

@delegate:ResourceContentHash(-215_227_754)
internal val Res.string.ui_devices_detail_devicedui_label_active_campaigns: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_active_campaigns", "ui_devices_detail_devicedui_label_active_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11254, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10698, 82),
      ))
    }

@delegate:ResourceContentHash(-1_572_294_076)
internal val Res.string.ui_devices_detail_devicedui_label_campaign_id_prefix: StringResource by
    lazy {
      StringResource("string:ui_devices_detail_devicedui_label_campaign_id_prefix", "ui_devices_detail_devicedui_label_campaign_id_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11337, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10781, 84),
      ))
    }

@delegate:ResourceContentHash(-1_892_599_668)
internal val Res.string.ui_devices_detail_devicedui_label_duration_priority: StringResource by
    lazy {
      StringResource("string:ui_devices_detail_devicedui_label_duration_priority", "ui_devices_detail_devicedui_label_duration_priority", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11422, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10866, 99),
      ))
    }

@delegate:ResourceContentHash(81_821_120)
internal val Res.string.ui_devices_detail_devicedui_label_id: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_id", "ui_devices_detail_devicedui_label_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11522, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10966, 48),
      ))
    }

@delegate:ResourceContentHash(1_892_315_140)
internal val Res.string.ui_devices_detail_devicedui_label_online_status: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_online_status", "ui_devices_detail_devicedui_label_online_status", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11571, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11015, 75),
      ))
    }

@delegate:ResourceContentHash(-902_466_203)
internal val Res.string.ui_devices_detail_devicedui_label_opening_hours: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_opening_hours", "ui_devices_detail_devicedui_label_opening_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11651, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11091, 75),
      ))
    }

@delegate:ResourceContentHash(-576_114_565)
internal val Res.string.ui_devices_detail_devicedui_label_resolution: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_resolution", "ui_devices_detail_devicedui_label_resolution", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11727, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11167, 68),
      ))
    }

@delegate:ResourceContentHash(-1_707_257_235)
internal val Res.string.ui_devices_detail_devicedui_label_type: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_type", "ui_devices_detail_devicedui_label_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11796, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11236, 54),
      ))
    }

@delegate:ResourceContentHash(1_308_036_181)
internal val Res.string.ui_devices_detail_devicedui_label_versions: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_label_versions", "ui_devices_detail_devicedui_label_versions", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11851, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11291, 62),
      ))
    }

@delegate:ResourceContentHash(-1_600_695_492)
internal val Res.string.ui_devices_detail_devicedui_status_closed: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_status_closed", "ui_devices_detail_devicedui_status_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11914, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11354, 57),
      ))
    }

@delegate:ResourceContentHash(1_769_579_710)
internal val Res.string.ui_devices_detail_devicedui_status_offline: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_status_offline", "ui_devices_detail_devicedui_status_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11976, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11412, 62),
      ))
    }

@delegate:ResourceContentHash(-1_707_876_243)
internal val Res.string.ui_devices_detail_devicedui_status_online: StringResource by lazy {
      StringResource("string:ui_devices_detail_devicedui_status_online", "ui_devices_detail_devicedui_status_online", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12043, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11475, 57),
      ))
    }

@delegate:ResourceContentHash(1_609_547_695)
internal val Res.string.ui_devices_detail_monitoring_empty: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_empty", "ui_devices_detail_monitoring_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12105, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11533, 82),
      ))
    }

@delegate:ResourceContentHash(-252_798_588)
internal val Res.string.ui_devices_detail_monitoring_free: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_free", "ui_devices_detail_monitoring_free", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12188, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11616, 57),
      ))
    }

@delegate:ResourceContentHash(-1_474_408_480)
internal val Res.string.ui_devices_detail_monitoring_header_disk: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_disk", "ui_devices_detail_monitoring_header_disk", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12250, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11674, 56),
      ))
    }

@delegate:ResourceContentHash(2_142_257_332)
internal val Res.string.ui_devices_detail_monitoring_header_network: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_network", "ui_devices_detail_monitoring_header_network", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12393, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11817, 63),
      ))
    }

@delegate:ResourceContentHash(-1_480_788_192)
internal val Res.string.ui_devices_detail_monitoring_header_network_speed: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_network_speed", "ui_devices_detail_monitoring_header_network_speed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12307, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11731, 85),
      ))
    }

@delegate:ResourceContentHash(84_393_920)
internal val Res.string.ui_devices_detail_monitoring_header_ram: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_ram", "ui_devices_detail_monitoring_header_ram", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12453, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11881, 51),
      ))
    }

@delegate:ResourceContentHash(-590_140_832)
internal val Res.string.ui_devices_detail_monitoring_header_temp: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_temp", "ui_devices_detail_monitoring_header_temp", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12505, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11933, 56),
      ))
    }

@delegate:ResourceContentHash(-2_134_404_382)
internal val Res.string.ui_devices_detail_monitoring_header_timestamp: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_header_timestamp", "ui_devices_detail_monitoring_header_timestamp", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12562, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11990, 65),
      ))
    }

@delegate:ResourceContentHash(2_106_412_229)
internal val Res.string.ui_devices_detail_monitoring_offline: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_offline", "ui_devices_detail_monitoring_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12640, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12056, 56),
      ))
    }

@delegate:ResourceContentHash(2_138_183_680)
internal val Res.string.ui_devices_detail_monitoring_speed_format: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_speed_format", "ui_devices_detail_monitoring_speed_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12701, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12113, 73),
      ))
    }

@delegate:ResourceContentHash(820_523_378)
internal val Res.string.ui_devices_detail_monitoring_title: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_title", "ui_devices_detail_monitoring_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12775, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12187, 58),
      ))
    }

@delegate:ResourceContentHash(-281_637_087)
internal val Res.string.ui_devices_detail_monitoring_today: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_today", "ui_devices_detail_monitoring_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12826, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12246, 58),
      ))
    }

@delegate:ResourceContentHash(-712_948_530)
internal val Res.string.ui_devices_detail_monitoring_yesterday: StringResource by lazy {
      StringResource("string:ui_devices_detail_monitoring_yesterday", "ui_devices_detail_monitoring_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12885, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12305, 66),
      ))
    }

@delegate:ResourceContentHash(936_220_866)
internal val Res.string.ui_devices_edit_deviceeui_btn_save: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_btn_save", "ui_devices_edit_deviceeui_btn_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12948, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12372, 50),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_devices_edit_deviceeui_cancel: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_cancel", "ui_devices_edit_deviceeui_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12999, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12423, 48),
      ))
    }

@delegate:ResourceContentHash(-1_655_862_933)
internal val Res.string.ui_devices_edit_deviceeui_dialog_title_select_location: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_dialog_title_select_location", "ui_devices_edit_deviceeui_dialog_title_select_location", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13052, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12472, 82),
      ))
    }

@delegate:ResourceContentHash(-1_428_792_705)
internal val Res.string.ui_devices_edit_deviceeui_error: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_error", "ui_devices_edit_deviceeui_error", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13139, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12555, 47),
      ))
    }

@delegate:ResourceContentHash(407_123_856)
internal val Res.string.ui_devices_edit_deviceeui_label_address: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_address", "ui_devices_edit_deviceeui_label_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13191, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12603, 71),
      ))
    }

@delegate:ResourceContentHash(262_444_405)
internal val Res.string.ui_devices_edit_deviceeui_label_aspect_ratio: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_aspect_ratio", "ui_devices_edit_deviceeui_label_aspect_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13267, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12675, 68),
      ))
    }

@delegate:ResourceContentHash(-1_504_359_035)
internal val Res.string.ui_devices_edit_deviceeui_label_height: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_height", "ui_devices_edit_deviceeui_label_height", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13340, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12744, 54),
      ))
    }

@delegate:ResourceContentHash(-428_210_153)
internal val Res.string.ui_devices_edit_deviceeui_label_identification: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_identification", "ui_devices_edit_deviceeui_label_identification", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13395, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12799, 90),
      ))
    }

@delegate:ResourceContentHash(-1_385_667_318)
internal val Res.string.ui_devices_edit_deviceeui_label_location: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_location", "ui_devices_edit_deviceeui_label_location", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13486, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12890, 60),
      ))
    }

@delegate:ResourceContentHash(-902_466_203)
internal val Res.string.ui_devices_edit_deviceeui_label_openning_hours: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_openning_hours", "ui_devices_edit_deviceeui_label_openning_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13547, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12951, 74),
      ))
    }

@delegate:ResourceContentHash(-181_754_221)
internal val Res.string.ui_devices_edit_deviceeui_label_orientation: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_orientation", "ui_devices_edit_deviceeui_label_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13622, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13026, 67),
      ))
    }

@delegate:ResourceContentHash(1_185_549_412)
internal val Res.string.ui_devices_edit_deviceeui_label_registry_name: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_registry_name", "ui_devices_edit_deviceeui_label_registry_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13690, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13094, 81),
      ))
    }

@delegate:ResourceContentHash(-1_137_077_148)
internal val Res.string.ui_devices_edit_deviceeui_label_resolution_mode: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_resolution_mode", "ui_devices_edit_deviceeui_label_resolution_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13780, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13176, 75),
      ))
    }

@delegate:ResourceContentHash(-1_789_417_629)
internal val Res.string.ui_devices_edit_deviceeui_label_resolution_preset: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_resolution_preset", "ui_devices_edit_deviceeui_label_resolution_preset", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13860, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13252, 81),
      ))
    }

@delegate:ResourceContentHash(-1_749_834_787)
internal val Res.string.ui_devices_edit_deviceeui_label_technical_specs: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_technical_specs", "ui_devices_edit_deviceeui_label_technical_specs", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13946, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13334, 87),
      ))
    }

@delegate:ResourceContentHash(1_890_066_273)
internal val Res.string.ui_devices_edit_deviceeui_label_visual: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_visual", "ui_devices_edit_deviceeui_label_visual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14034, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13422, 66),
      ))
    }

@delegate:ResourceContentHash(-950_193_906)
internal val Res.string.ui_devices_edit_deviceeui_label_width: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_label_width", "ui_devices_edit_deviceeui_label_width", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14101, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13489, 53),
      ))
    }

@delegate:ResourceContentHash(637_200_222)
internal val Res.string.ui_devices_edit_deviceeui_mode_custom: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_mode_custom", "ui_devices_edit_deviceeui_mode_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14159, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13543, 53),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_campaigns_edit_visual_guidelines_title", Res.string.ui_campaigns_edit_visual_guidelines_title)
  map.put("ui_campaigns_edit_warn_name_required", Res.string.ui_campaigns_edit_warn_name_required)
  map.put("ui_campaigns_edit_warn_save_failed", Res.string.ui_campaigns_edit_warn_save_failed)
  map.put("ui_campaigns_edit_warn_select_device", Res.string.ui_campaigns_edit_warn_select_device)
  map.put("ui_campaigns_edit_warn_set_assets", Res.string.ui_campaigns_edit_warn_set_assets)
  map.put("ui_campaigns_listing_btn_new", Res.string.ui_campaigns_listing_btn_new)
  map.put("ui_campaigns_listing_btn_ok", Res.string.ui_campaigns_listing_btn_ok)
  map.put("ui_campaigns_listing_btn_reset", Res.string.ui_campaigns_listing_btn_reset)
  map.put("ui_campaigns_listing_filter_date_any", Res.string.ui_campaigns_listing_filter_date_any)
  map.put("ui_campaigns_listing_filter_date_format", Res.string.ui_campaigns_listing_filter_date_format)
  map.put("ui_campaigns_listing_filter_state_prefix", Res.string.ui_campaigns_listing_filter_state_prefix)
  map.put("ui_campaigns_listing_header_asset", Res.string.ui_campaigns_listing_header_asset)
  map.put("ui_campaigns_listing_header_geo", Res.string.ui_campaigns_listing_header_geo)
  map.put("ui_campaigns_listing_header_identity", Res.string.ui_campaigns_listing_header_identity)
  map.put("ui_campaigns_listing_header_interval", Res.string.ui_campaigns_listing_header_interval)
  map.put("ui_campaigns_listing_header_node", Res.string.ui_campaigns_listing_header_node)
  map.put("ui_campaigns_listing_header_reach", Res.string.ui_campaigns_listing_header_reach)
  map.put("ui_campaigns_listing_header_state", Res.string.ui_campaigns_listing_header_state)
  map.put("ui_campaigns_listing_header_visual", Res.string.ui_campaigns_listing_header_visual)
  map.put("ui_campaigns_listing_search_placeholder", Res.string.ui_campaigns_listing_search_placeholder)
  map.put("ui_campaigns_listing_showing", Res.string.ui_campaigns_listing_showing)
  map.put("ui_campaigns_splash_desc", Res.string.ui_campaigns_splash_desc)
  map.put("ui_campaigns_splash_title", Res.string.ui_campaigns_splash_title)
  map.put("ui_company_dialog_btn_cancel", Res.string.ui_company_dialog_btn_cancel)
  map.put("ui_company_dialog_btn_confirm", Res.string.ui_company_dialog_btn_confirm)
  map.put("ui_company_dialog_btn_delete", Res.string.ui_company_dialog_btn_delete)
  map.put("ui_company_dialog_btn_rename", Res.string.ui_company_dialog_btn_rename)
  map.put("ui_company_dialog_btn_switch", Res.string.ui_company_dialog_btn_switch)
  map.put("ui_company_dialog_delete_title", Res.string.ui_company_dialog_delete_title)
  map.put("ui_company_dialog_delete_warning", Res.string.ui_company_dialog_delete_warning)
  map.put("ui_company_dialog_rename_placeholder", Res.string.ui_company_dialog_rename_placeholder)
  map.put("ui_company_dialog_rename_title", Res.string.ui_company_dialog_rename_title)
  map.put("ui_company_dialog_title", Res.string.ui_company_dialog_title)
  map.put("ui_company_listing_btn_add_company", Res.string.ui_company_listing_btn_add_company)
  map.put("ui_company_listing_btn_load_more", Res.string.ui_company_listing_btn_load_more)
  map.put("ui_company_listing_header_counters", Res.string.ui_company_listing_header_counters)
  map.put("ui_company_listing_header_name", Res.string.ui_company_listing_header_name)
  map.put("ui_company_listing_no_companies_found", Res.string.ui_company_listing_no_companies_found)
  map.put("ui_company_listing_search_placeholder", Res.string.ui_company_listing_search_placeholder)
  map.put("ui_company_listing_showing", Res.string.ui_company_listing_showing)
  map.put("ui_company_splash_desc", Res.string.ui_company_splash_desc)
  map.put("ui_company_splash_title", Res.string.ui_company_splash_title)
  map.put("ui_devices_detail_device_actions_btn_close", Res.string.ui_devices_detail_device_actions_btn_close)
  map.put("ui_devices_detail_device_actions_btn_reboot", Res.string.ui_devices_detail_device_actions_btn_reboot)
  map.put("ui_devices_detail_device_actions_btn_update_runtime", Res.string.ui_devices_detail_device_actions_btn_update_runtime)
  map.put("ui_devices_detail_device_actions_btn_update_www", Res.string.ui_devices_detail_device_actions_btn_update_www)
  map.put("ui_devices_detail_device_actions_dialog_title", Res.string.ui_devices_detail_device_actions_dialog_title)
  map.put("ui_devices_detail_device_actions_reboot_queued", Res.string.ui_devices_detail_device_actions_reboot_queued)
  map.put("ui_devices_detail_device_actions_update_queued", Res.string.ui_devices_detail_device_actions_update_queued)
  map.put("ui_devices_detail_devicedui_btn_cancel", Res.string.ui_devices_detail_devicedui_btn_cancel)
  map.put("ui_devices_detail_devicedui_btn_delete", Res.string.ui_devices_detail_devicedui_btn_delete)
  map.put("ui_devices_detail_devicedui_btn_device_actions", Res.string.ui_devices_detail_devicedui_btn_device_actions)
  map.put("ui_devices_detail_devicedui_btn_edit", Res.string.ui_devices_detail_devicedui_btn_edit)
  map.put("ui_devices_detail_devicedui_btn_screenshot", Res.string.ui_devices_detail_devicedui_btn_screenshot)
  map.put("ui_devices_detail_devicedui_campaigns_empty", Res.string.ui_devices_detail_devicedui_campaigns_empty)
  map.put("ui_devices_detail_devicedui_delete_confirm_message", Res.string.ui_devices_detail_devicedui_delete_confirm_message)
  map.put("ui_devices_detail_devicedui_delete_confirm_title", Res.string.ui_devices_detail_devicedui_delete_confirm_title)
  map.put("ui_devices_detail_devicedui_label_active_campaigns", Res.string.ui_devices_detail_devicedui_label_active_campaigns)
  map.put("ui_devices_detail_devicedui_label_campaign_id_prefix", Res.string.ui_devices_detail_devicedui_label_campaign_id_prefix)
  map.put("ui_devices_detail_devicedui_label_duration_priority", Res.string.ui_devices_detail_devicedui_label_duration_priority)
  map.put("ui_devices_detail_devicedui_label_id", Res.string.ui_devices_detail_devicedui_label_id)
  map.put("ui_devices_detail_devicedui_label_online_status", Res.string.ui_devices_detail_devicedui_label_online_status)
  map.put("ui_devices_detail_devicedui_label_opening_hours", Res.string.ui_devices_detail_devicedui_label_opening_hours)
  map.put("ui_devices_detail_devicedui_label_resolution", Res.string.ui_devices_detail_devicedui_label_resolution)
  map.put("ui_devices_detail_devicedui_label_type", Res.string.ui_devices_detail_devicedui_label_type)
  map.put("ui_devices_detail_devicedui_label_versions", Res.string.ui_devices_detail_devicedui_label_versions)
  map.put("ui_devices_detail_devicedui_status_closed", Res.string.ui_devices_detail_devicedui_status_closed)
  map.put("ui_devices_detail_devicedui_status_offline", Res.string.ui_devices_detail_devicedui_status_offline)
  map.put("ui_devices_detail_devicedui_status_online", Res.string.ui_devices_detail_devicedui_status_online)
  map.put("ui_devices_detail_monitoring_empty", Res.string.ui_devices_detail_monitoring_empty)
  map.put("ui_devices_detail_monitoring_free", Res.string.ui_devices_detail_monitoring_free)
  map.put("ui_devices_detail_monitoring_header_disk", Res.string.ui_devices_detail_monitoring_header_disk)
  map.put("ui_devices_detail_monitoring_header_network", Res.string.ui_devices_detail_monitoring_header_network)
  map.put("ui_devices_detail_monitoring_header_network_speed", Res.string.ui_devices_detail_monitoring_header_network_speed)
  map.put("ui_devices_detail_monitoring_header_ram", Res.string.ui_devices_detail_monitoring_header_ram)
  map.put("ui_devices_detail_monitoring_header_temp", Res.string.ui_devices_detail_monitoring_header_temp)
  map.put("ui_devices_detail_monitoring_header_timestamp", Res.string.ui_devices_detail_monitoring_header_timestamp)
  map.put("ui_devices_detail_monitoring_offline", Res.string.ui_devices_detail_monitoring_offline)
  map.put("ui_devices_detail_monitoring_speed_format", Res.string.ui_devices_detail_monitoring_speed_format)
  map.put("ui_devices_detail_monitoring_title", Res.string.ui_devices_detail_monitoring_title)
  map.put("ui_devices_detail_monitoring_today", Res.string.ui_devices_detail_monitoring_today)
  map.put("ui_devices_detail_monitoring_yesterday", Res.string.ui_devices_detail_monitoring_yesterday)
  map.put("ui_devices_edit_deviceeui_btn_save", Res.string.ui_devices_edit_deviceeui_btn_save)
  map.put("ui_devices_edit_deviceeui_cancel", Res.string.ui_devices_edit_deviceeui_cancel)
  map.put("ui_devices_edit_deviceeui_dialog_title_select_location", Res.string.ui_devices_edit_deviceeui_dialog_title_select_location)
  map.put("ui_devices_edit_deviceeui_error", Res.string.ui_devices_edit_deviceeui_error)
  map.put("ui_devices_edit_deviceeui_label_address", Res.string.ui_devices_edit_deviceeui_label_address)
  map.put("ui_devices_edit_deviceeui_label_aspect_ratio", Res.string.ui_devices_edit_deviceeui_label_aspect_ratio)
  map.put("ui_devices_edit_deviceeui_label_height", Res.string.ui_devices_edit_deviceeui_label_height)
  map.put("ui_devices_edit_deviceeui_label_identification", Res.string.ui_devices_edit_deviceeui_label_identification)
  map.put("ui_devices_edit_deviceeui_label_location", Res.string.ui_devices_edit_deviceeui_label_location)
  map.put("ui_devices_edit_deviceeui_label_openning_hours", Res.string.ui_devices_edit_deviceeui_label_openning_hours)
  map.put("ui_devices_edit_deviceeui_label_orientation", Res.string.ui_devices_edit_deviceeui_label_orientation)
  map.put("ui_devices_edit_deviceeui_label_registry_name", Res.string.ui_devices_edit_deviceeui_label_registry_name)
  map.put("ui_devices_edit_deviceeui_label_resolution_mode", Res.string.ui_devices_edit_deviceeui_label_resolution_mode)
  map.put("ui_devices_edit_deviceeui_label_resolution_preset", Res.string.ui_devices_edit_deviceeui_label_resolution_preset)
  map.put("ui_devices_edit_deviceeui_label_technical_specs", Res.string.ui_devices_edit_deviceeui_label_technical_specs)
  map.put("ui_devices_edit_deviceeui_label_visual", Res.string.ui_devices_edit_deviceeui_label_visual)
  map.put("ui_devices_edit_deviceeui_label_width", Res.string.ui_devices_edit_deviceeui_label_width)
  map.put("ui_devices_edit_deviceeui_mode_custom", Res.string.ui_devices_edit_deviceeui_mode_custom)
}
